<template>
<nav id="purchasable-item-nav">
  <ul class="nav nav-pills">
    <li>
      <router-link :to="{
        name: 'create_purchasable_item'
      }">
        New Purchasable Item
      </router-link>
    </li>
    <li v-if="purchasableItemId && this.$parent.$parent.role === 'admin'">
      <router-link :to="{
        name: 'edit_purchasable_item',
        params: { purchasableItemId: purchasableItemId }
        }"
      >
        Edit Purchasable Item
      </router-link>
    </li>
    <li v-if="purchasableItemId && this.$parent.$parent.role === 'admin'">
      <router-link :to="{
        name: 'purchasable_item_purchases',
        params: { purchasableItemId: purchasableItemId }
        }"
      >
        View Sales Chart
      </router-link>
    </li>
  </ul>
</nav>
</template>

<script>
export default {
  props: ['purchasableItemId']
}
</script>

<style scoped>
main nav {
  margin-bottom: 1em;
}

.nav {
  border-top: 0
}
</style>



// WEBPACK FOOTER //
// src/components/PurchasableItemNav.vue